import React, { Component } from 'react'
import { observer } from 'mobx-react'
import UIOpenText from '@ui/QuestionsType/OpenText'

@observer
export default class OpenText extends Component {
  render() {
    const { mapped, onPartial, inactive } = this.props
    return (
      <UIOpenText
        onChange={onPartial}
        value={mapped.answer || ''}
        readOnly={inactive}
      />
    )
  }
}
